import type { MapaResposta } from '../types';
import type { Escala } from './escalas';

type EscalaComRotulos = Escala & { rotulosLegenda?: [string, string, string] };

/** Legenda: gradiente com extremos rotulados, mais o que significa "sem dados". */
export function Legenda({ escala, dados, nota }: { escala: EscalaComRotulos; dados: Pick<MapaResposta, 'semDados' | 'comDados'> | null; nota?: string }) {
  const [lo, hi] = escala.dominio;
  const meio = (lo + hi) / 2;
  const rotulos = escala.rotulosLegenda ?? [escala.rotulo(lo), escala.rotulo(Math.round(meio * 10) / 10), escala.rotulo(hi)];
  return (
    <div class="legenda" aria-label={`Legenda: ${escala.titulo}`}>
      <div class="legenda-titulo">{escala.titulo}</div>
      <div class="legenda-barra" style={{ background: `linear-gradient(to right, ${escala.gradiente.join(', ')})` }} />
      <div class="legenda-rotulos">
        <span>{rotulos[0]}</span>
        <span>{rotulos[1]}</span>
        <span>{rotulos[2]}</span>
      </div>
      {nota && <div class="legenda-nota">{nota}</div>}
      <div class="legenda-semdado">
        <i class="amostra-semdado" /> Sem dados
        {dados && <span class="legenda-contagem"> · {dados.semDados} de {dados.comDados + dados.semDados}</span>}
      </div>
    </div>
  );
}
